import { type PostUserLoginAuthTokenPayload } from '@capsicum/common';

import { useUserAuthValidationQuery } from '../data-access';

export type QueryAuthParams = {
	consumerName?: string;
	deviceName?: string;
	deviceUid: string;
	generatedCode: string;
	locale?: string;
	userId: string;
	webApp: string;
};

/**
 * Hook calling auth validation query
 * @params {QueryTotalParams} urlParams - params we get from the URL
 *
 * @returns {UserLoginAuthTokenPost} - react query calling authenticate endpoint
 */
export const useUserAuthValidation = (urlParams: QueryAuthParams) => {
	const { deviceUid, generatedCode, userId, webApp } = urlParams;
	const payload: PostUserLoginAuthTokenPayload = {
		consumerName: `socios ${webApp ? 'web' : 'mobile'} app`,
		deviceUid,
		generatedCode,
		userId
	};

	return useUserAuthValidationQuery(payload);
};
